import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FieldValidationComponent } from './field-validation.component';

@NgModule({
  declarations: [FieldValidationComponent],
  exports: [FieldValidationComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule]
})
export class FieldValidationModule { }
